// set min-height to improve CLS
if ($('.category-page #searchspring-content').length) {
    function setPageHeight() {
        let currentURL = window.location.href;
        if (currentURL.indexOf("filter:") > -1) {
            $('.category-page #searchspring-content').css('min-height', '50vh')
        }
        else {
            $('.category-page #searchspring-content').css('min-height', '70vh')
        }
    }

    $('body').on('click', '.ss-list-option a', function() {
        setPageHeight();
    })

    setPageHeight();
}